<template>
  <!--购物车页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    @scroll="watchScroll"
  >
    <!--头部-->
    <gradient-header slot="header" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important' }">确定订单</div>
    </gradient-header>
    <!--背景图片渲染-->
    <div class="content-box" :style="`background-image: url(${orderImage}) !important`">
      <!--订单地址-->
      <div class="m-x-12 m-t-32">
        <tk-card
          :height="85"
          :width="100"
          :is-between="true"
          :is-middle="true"
          @click.native="$push({ path: '/itsMine/shippingAddress', query: { isSelected: true }})"
        >
          <div style="width: 90%;" v-if="selectedAddress">
            <div class="font-18 font-bold">{{selectedAddress.name}} <span class="m-l-10">{{selectedAddress.phone}}</span></div>
            <div class="font-14 primary-gray m-t-10 van-ellipsis">
              {{$tkRegions.getFullName(selectedAddress.region) + selectedAddress.address}}
            </div>
          </div>
          <div v-else class="font-14 primary-gray">
            请选择配送地址
          </div>
          <div class="m-l-5">
            <tk-icon size="14" color="#C1C1C1">rightarrow</tk-icon>
          </div>
        </tk-card>
      </div>
    </div>
    <!--支付方式-->
    <!-- <div class="m-x-12 m-t-10">
      <tk-card
        :height="94"
        :width="100"
        :is-middle="true"
      >
        <tk-flex
          between middle
          @click.native="selectedChannel(index)"
          class="font-14 full-width"
          v-for="(s, index) in payList"
          :class="{'m-t-15': index !== 0}"
          :key="index"
        >
          <tk-flex middle>
            <tk-icon size="22" v-if="s.icon === 'alipay'">{{s.icon}}</tk-icon>
            <tk-icon size="24" v-else>{{s.icon}}</tk-icon>
            <span class="m-l-12">{{s.text}}</span>
          </tk-flex>
          <tkui-toggle type="round" v-model="s.isSelected"></tkui-toggle>
        </tk-flex>
      </tk-card>
    </div> -->
    <!--要结算的商品-->
    <div class="m-x-12">
      <card
        :width="100" :height="50"
        v-if="selectedProductsData.length"
        class="m-y-10"
      >
        <div
          v-for="(s, index) in selectedProductsData"
          :key="`car${index}`"
        >
          <!--商家名字-->
          <div style="font-size: 15px;">{{merchantsName(s.merchants)}}</div>
          <!--商品列表-->
          <div
            v-for="(m, index) in s.commodityData"
            :key="`commodity${index}`"
          >
            <tk-flex
              middle
              class="m-t-10"
            >
              <div class="commodity-style-image">
                <tk-image :src="m.showPictures[0]" :width="90" :height="90"></tk-image>
              </div>
              <tk-flex top class="m-l-10 full-width" column>
                <div class="class-card-wrap font-14">{{m.productTitle}}</div>
                <div style="height: 20px;"></div>
                <tk-flex middle class="full-width">
                  <div class="commodity-style-price"><span class="font-10">￥</span>{{m.price}}</div>
                  <div class="primary-gray font-14 m-l-15">{{'×' + m.numberOrders}}</div>
                  <tk-flex
                    bottom
                    right class="full-width"><span class="font-10">￥</span>{{getPoint(m.price, m.numberOrders)}}</tk-flex>
                </tk-flex>
              </tk-flex>
            </tk-flex>
          </div>
        </div>
        <!--买家留言-->
        <tk-flex middle class="m-t-10">
          <div class="font-14">买家留言</div>
          <label>
            <input v-model="leaveMessage" type="text" class="leave-input" placeholder="建议先与商家沟通确认"/>
          </label>
        </tk-flex>
      </card>
    </div>
    <!--优惠券运费券欢乐的使用-->
    <div class="m-x-12" v-if="isCountyAccount">
      <tk-card :width="100" :height="132" is-middle>
        <tk-flex
          between
          class="full-width"
          :class="{'m-t-15': index > 0}"
          @click.native="selectedCoupon(s)"
          v-for="(s, index) in selectDiscount"
          :key="index"
        >
          <div class="font-14">{{s.text}}</div>
          <tk-flex middle class="primary-gray">
            <div class="caption">
              {{s.number > 0 ? s.number + '张' : '暂无可用'}}
              <tk-icon size="14" class="m-l-10" color="#C1C1C1">downarrow</tk-icon>
            </div>
          </tk-flex>
        </tk-flex>
        <tk-flex between class="full-width m-t-15">
          <div class="font-14">
            欢乐豆
            <span class="font-12 primary-gray m-l-12">共{{happyBeanSum}}个</span>
          </div>
          <tkui-toggle type="round" @click.native="selectedHappyBean" :disabled="discountOrderAmount <= 0 || !happyBeanSum" v-model="selectedBean"></tkui-toggle>
        </tk-flex>
      </tk-card>
    </div>
    <!--使用优惠券运费券欢乐豆后的联动-->
    <div class="m-x-12 m-t-10" v-if="isCountyAccount">
      <tk-card :width="100" :height="132" is-middle>
        <tk-flex between class="full-width">
          <div class="font-14">
            商品总额
          </div>
          <div>
            <span class="font-10">￥</span>{{settlementAmount}}
          </div>
        </tk-flex>
        <tk-flex
          between
          class="full-width m-t-15"
        >
          <div class="font-14">优惠券</div>
          <div class="primary">-<span class="font-10">￥</span>{{couponsDiscount}}</div>
        </tk-flex>
        <tk-flex
          between
          class="full-width m-t-15"
        >
          <div class="font-14">运费券</div>
          <div class="primary">-<span class="font-10">￥</span>{{freightVouchersDiscount}}</div>
        </tk-flex>
        <tk-flex between class="full-width m-t-15">
          <div class="font-14">
            欢乐豆<span class="caption" style="margin-left: 14px;">{{`消耗${subtractBeanSum}个欢乐豆`}}</span>
          </div>
          <div class="primary">
            -<span class="font-10">￥</span>{{happyBeanDiscount}}
          </div>
        </tk-flex>
      </tk-card>
    </div>
    <div style="height: 10px;"></div>
    <!--优惠券列表弹窗-->
    <tk-cover
      :show.sync="selectedShow"
      transition
      bottom
    >
      <card
        :width="100"
        :height="280"
        style="border-radius: 25px 25px 0 0;"
        class="p-0 tk-scroller"
      >
        <tk-flex between middle class="p-l-30 p-r-32 p-t-15">
          <div class="text-center full-width">可使用列表</div>
          <!--关闭按钮-->
          <tk-icon :color="'#d3d3d3'" @click.native="cancelSelected" :size="12">guanbi</tk-icon>
        </tk-flex>
        <template v-if="vouchers.length">
          <div class="p-x-30">
            <tkui-list-select
              type="round"
              style="width: 100%;"
              v-model="selectedVouchers"
              :items="selectedList"
              :toggle="'round'"
              showDeselect
              class="font-14"
              @click.native="selectedId(selectedVouchers)"
            >
            </tkui-list-select>
          </div>
        </template>
      </card>
    </tk-cover>
    <!--footer底部-->
    <footer slot="footer">
      <tk-card is-middle :height="50" :width="100" is-between>
        <div class="font-13 font-bold">
          合计：
          <span class="primary font-bold font-20">
            <span class="font-12">￥</span>{{discountOrderAmount * 100 / 100}}
          </span>
        </div>
        <tkui-button
          class="small primary raised settlement-btn"
          :disabled="settlementDisabled"
          @click="settlementOrder"
        >
          去支付
        </tkui-button>
      </tk-card>
    </footer>
  </tk-container>
</template>

<script>
import { floatingPoint, priceProcessing, payMoney } from '@/assets/help/tool'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      isHeaderColor: false, // 判断头部颜色切换
      selectedBean: false, // 选择使用欢乐豆状态
      settlementDisabled: false, // 去结算的按钮状态
      selectedAddress: null, // 用户地址
      selectedShow: false, // 选择优惠券弹窗状态
      wallet: null, // 钱包数据
      selectedVouchers: '', // 选择的值
      selectedCoupons: null, // 选定使用的优惠券id
      selectedFreight: null, // 选定使用的运费券id
      leaveMessage: '', // 留言信息
      payChannel: 'ALI_APP', // 选定的支付通道
      happyBeanDiscount: 0, // 欢乐豆优惠金额
      subtractBeanSum: 0, // 需要减去的欢乐豆数量
      couponsDiscount: 0, // 优惠券优惠金额
      freightVouchersDiscount: 0, // 运费券优惠金额
      vouchers: [], // 优惠券数据
      shoppingCart: null, // 购物车数据
      payList: [ // 支付方式
        {
          icon: 'alipay',
          text: '支付宝',
          payChannel: 'ALI_APP',
          isSelected: true
        }, {
          icon: 'wechat',
          text: '微信',
          payChannel: 'WX_APP',
          isSelected: false
        }
      ],
      selectDiscount: [ // 券数据
        {
          text: '优惠券',
          type: 'coupons',
          number: 0
        }, {
          text: '运费券',
          type: 'freightVouchers',
          number: 0
        }
      ],
      selectedType: '', // 选择的优惠券类型
      discountList: [ // 券数据
        {
          text: '优惠券',
          type: 'coupons',
          amount: 0
        }, {
          text: '运费券',
          type: 'freightVouchers',
          amount: 0
        }
      ]
    }
  },
  computed: {
    // 选择的收货地址id
    addressId () {
      return this.$store.state.addressId
    },
    // 欢乐豆
    happyBeanSum () {
      if (!this.wallet || (this.wallet && !this.wallet.happyBean)) { return 0 }
      return this.wallet.happyBean
    },
    // 选择要结算的订单
    selectedProductsData () {
      return this.$store.state.selectedProductsData
    },
    // 计算要结算商品总额
    settlementAmount () {
      let sum = 0
      this.selectedProductsData.forEach(s => {
        s.commodityData.forEach(s => {
          sum = floatingPoint(sum, floatingPoint(s.price, s.numberOrders, 'multiply'), 'add')
        })
      })
      return sum
    },
    // 计算优惠后的订单金额
    discountOrderAmount () {
      let num = this.couponsDiscount + this.freightVouchersDiscount + this.happyBeanDiscount
      let sum = floatingPoint(this.settlementAmount, num, 'subtract')
      if (sum <= 0) { return 0 }
      return sum
    },
    // 选择优惠券列表
    selectedList () {
      let obj = {}
      this.vouchers.forEach(s => {
        obj[s.objectId] = s.name + ' ' + '可优惠：' + s.parValue + `(订单总金额满${s.conditionsUse})`
      })
      return obj
    }
  },
  watch: {
    async addressId () {
      await this.getUserAddress()
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    if (to.path !== '/itsMine/shippingAddress') {
      this.$store.commit('setSelectedData', [])
    }
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/4/1
     */
    async getInit () {
      try {
        await this.getUserAddress() // 获取用户选择的收货地址
        await this.getWallet() // 获取用户钱包
        if (this.$route.query.type === 'shoppingCar') {
          await this.getShoppingCart() // 获取购物车数据
        }
        this.selectDiscount[0].number = await this.statisticsNum('vouchers',
          { type: 'coupons', user: this.userInfo.objectId, status: 'notUsed', conditionsUse: { $lte: this.settlementAmount } }
        ) // 获取优惠券数量
        this.selectDiscount[1].number = await this.statisticsNum('vouchers',
          { type: 'freightVouchers', user: this.userInfo.objectId, status: 'notUsed', conditionsUse: { $lte: this.settlementAmount } }
        ) // 获取优惠券数量
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 获取用户收货地址信息
     * @date: 2020/4/28
     */
    async getUserAddress () {
      if (this.addressId && await this.judgeId(this.addressId, 'shippingAddress')) {
        this.selectedAddress = await this.$tkParse.getData(`/classes/shippingAddress/${this.addressId}`)
        return
      }
      let address = await this.$tkParse.getList('/classes/shippingAddress', { params:
          {
            limit: 1,
            where: { user: this.userInfo.objectId, default: 'yes' }
          } })
      if (address.length) {
        this.selectedAddress = address[0]
        this.$store.commit('setAddressId', address[0].objectId)
      } else {
        this.selectedAddress = null
      }
    },
    /**
     * 获取用户钱包
     * @date: 2020/4/11
     */
    async getWallet () {
      let wallet = await this.$tkParse.getList('/classes/wallet', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (wallet.length) { this.wallet = wallet[0] } else { this.wallet = null }
    },
    /**
    * 获取购物车数据
    * @date: 2020/4/29
    */
    async getShoppingCart () {
      if (!this.$route.query.id || (this.$route.query.id && !await this.judgeId(this.$route.query.id, 'shoppingCart'))) { return }
      this.shoppingCart = await this.$tkParse.getData(`/classes/shoppingCart/${this.$route.query.id}`)
    },
    /**
     * 商家名字
     * @date: 2020/4/1
     */
    merchantsName (merchants) {
      if (merchants.accountCategory === 'countyAccount') {
        return `${merchants.name}`
      }
      if (merchants.accountCategory === 'factoryAccount') {
        return merchants.brandName ? `${merchants.brandName}` : `厂家`
      }
    },
    /**
    * 去除商品合计浮点
    * @date: 2020/6/8
    */
    getPoint (price, numberOrders) {
      return floatingPoint(price, numberOrders, 'multiply')
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
    * 选定支付方式
    * @date: 2020/4/28
    */
    selectedChannel (index) {
      this.payList.forEach(s => { s.isSelected = false })
      this.payList[index].isSelected = true
      this.payChannel = this.payList[index].payChannel
    },
    /**
    * 选择优惠券
    * @date: 2020/4/29
    */
    async selectedCoupon (s) {
      if (!s.number) { return }
      this.selectedType = s.type
      this.selectedVouchers = ''
      let vouchers = await this.$tkParse.getList('/classes/vouchers', {
        params: {
          limit: 1000,
          where: {
            type: s.type,
            user: this.userInfo.objectId,
            status: 'notUsed',
            conditionsUse: {
              $lte: this.settlementAmount
            }
          }
        }
      })
      if (vouchers.length) { this.vouchers = vouchers } else { vouchers = [] }
      if (this.selectedCoupons && s.type === 'coupons') { this.selectedVouchers = this.selectedCoupons }
      if (this.selectedFreight && s.type === 'freightVouchers') { this.selectedVouchers = this.selectedFreight }
      this.selectedShow = true
    },
    /**
    * 取消优惠券
    * @date: 2020/7/2
    */
    cancelSelected () {
      this.selectedShow = false
    },
    /**
    * 选定使用的优惠券
    * @date: 2020/4/29
    */
    selectedId (id) {
      if (!id) {
        if (this.selectedType === 'coupons') {
          this.selectedCoupons = ''
          this.couponsDiscount = 0
        } else {
          this.selectedFreight = ''
          this.freightVouchersDiscount = 0
        }
        return
      }
      let s = this.vouchers.find(s => { return s.objectId === id })
      if (this.selectedType === 'coupons') {
        if (this.discountOrderAmount <= 0 && !this.couponsDiscount) {
          this.selectedVouchers = ''
          this.selectedShow = false
          return this.$tkGlobal.toast.add('优惠券使用已达上限')
        }
        this.selectedCoupons = id
        this.couponsDiscount = s.parValue
      } else {
        if (this.discountOrderAmount <= 0 && !this.freightVouchersDiscount) {
          this.selectedVouchers = ''
          this.selectedShow = false
          return this.$tkGlobal.toast.add('运费券使用已达上限')
        }
        this.selectedFreight = id
        this.freightVouchersDiscount = s.parValue
      }
      this.selectedShow = false
    },
    /**
    * 选择欢乐豆
    * @date: 2020/4/29
    */
    selectedHappyBean () {
      let happyBeanAmount = this.happyBeanSum / 100
      if (!this.selectedBean) {
        this.happyBeanDiscount = 0
        this.subtractBeanSum = 0
        return
      }
      if (this.discountOrderAmount >= happyBeanAmount) { // 如果可以全抵扣
        this.happyBeanDiscount = happyBeanAmount
        this.subtractBeanSum = this.happyBeanSum
      } else {
        // this.happyBeanDiscount = floatingPoint(happyBeanAmount, this.discountOrderAmount, 'subtract')
        // this.subtractBeanSum = this.happyBeanDiscount
        this.happyBeanDiscount = this.discountOrderAmount
        this.subtractBeanSum = floatingPoint(this.happyBeanDiscount, 100, 'multiply')
      }
    },
    /**
    * 结算订单
    * @date: 2020/4/29
    */
    async settlementOrder () {
      try {
        if (!this.selectedAddress) {
          return this.$tkGlobal.toast.add('请先选择收货地址')
        }
        // if (!this.discountOrderAmount) {
        //   return this.$tkGlobal.toast.add('没找到您要购买的商品')
        // }
        if (!this.selectedProductsData.length) {
          this.settlementDisabled = true
          this.$tkGlobal.toast.add('没找到您要购买的商品')
        }
        this.status = 'waiting'
        this.settlementDisabled = true
        // 准备给云接口传参数
        let orderObj = {
          selectedCoupons: this.selectedCoupons, // 选择的优惠券
          selectedFreight: this.selectedFreight, // 选择的运费券
          subtractBeanSum: this.subtractBeanSum, // 选择抵扣的欢乐豆
          userId: this.userInfo.objectId, // 用户的id
          settlementAmount: this.settlementAmount, // 订单的金额
          type: this.$route.query.type, // 结算的数据类型
          selectedProductsData: this.selectedProductsData, // 选定要结算的数据
          shoppingCart: this.shoppingCart, // 购物车数据
          carId: this.$route.query.id, // 购物车数据id
          merchants: this.selectedProductsData[0].merchants.objectId, // 商户id
          discountOrderAmount: this.discountOrderAmount, // 结算的金额
          leaveMessage: this.leaveMessage, // 用户留言
          addressId: this.addressId, // 选择地址的Id
          payChannel: this.payChannel // 选定的支付方式
        }
        // 创建订单
        let order = await this.$cloudAjax.post('/wxpay/$createOrder', orderObj).catch(e => {
          this.status = false
          this.settlementDisabled = false
          throw this.$tkGlobal.toast.add(e.data ? e.data : '生成订单失败')
        })
        // 支付订单
        let payStatus = await payMoney(order.data, this.discountOrderAmount, 'WX_APP')
        if (!payStatus) {
          this.status = false
          this.settlementDisabled = false
          this.$tkGlobal.toast.add('付款失败')
          return
        }
        orderObj.orderId = order.data
        if (orderObj.discountOrderAmount === 0) {
          orderObj.trade_success = true
          await this.$cloudAjax.post('/wxpay/$payOrder', orderObj).catch(e => {
            this.status = false
            this.settlementDisabled = false
            throw this.$tkGlobal.toast.add(e.data ? e.data : '付款失败，请联系客服')
          })
        }
        // 如果为购物车数据需重新统计购物车提示数量
        if (this.$route.query.type === 'shoppingCar') {
          // 重新计算购物车数量
          let sum = 0
          await this.getShoppingCart()
          if (!this.shoppingCart || (this.shoppingCart && !this.shoppingCart.data)) {
            this.$store.commit('setShoppingSum', 0)
            return
          }
          this.shoppingCart.data.forEach(s => {
            if (!s.commodityData) { s.commodityData = [] }
            sum += s.commodityData.length
          })
          this.$store.commit('setShoppingSum', sum)
        }
        await this.getInit()
        this.$tkGlobal.toast.add('付款成功')
        this.$push({ path: '/order/paySuccess', query: { id: order.data } })
        await this.$tkHelper.sleep(500)
        this.status = false
        this.settlementDisabled = false
      } catch (e) {
        this.status = false
        this.settlementDisabled = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .header-editor {
    width: 60px;
    height: 30px;
    line-height: 30px;
  }
  /*后台数据渲染样式*/
  .content-box {
    /*background-position: center center;*/
    padding-top: 70px;
    background-repeat:  no-repeat;
    background-size: 100% auto;
    min-height: 180px;
    .card-address {
      width: 100%;
      min-height: 85px;
      background: #fff;
      padding: 15px;
      border-radius: 5px;
    }
  }
  /*支付样式*/
  .card-pay {
    width: 100%;
    min-height: 94px;
    background: #fff;
    padding: 20px 15px;
    border-radius: 5px;
  }
  /*图片样式*/
  .commodity-style-image {
    width: 85px;
    border-radius: 5px;
    overflow: hidden;
  }
  /*优惠列表样式*/
  .tk-scroller {
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  /*买家留言样式*/
  .leave-input {
    margin-left: 18px;
    font-size: 14px;
  }
  .leave-input::-webkit-input-placeholder {
    font-size: 12px !important;
    color: rgba(153, 153, 153, 1);
  }
  .leave-input::placeholder {
    font-size: 12px !important;
    color: rgba(153, 153, 153, 1);
  }
  /*底部样式*/
  .settlement-btn {
    width: 85px;
    height: 36px;
    background:linear-gradient(90deg,rgba(248,69,39,1),rgba(207,22,19,1));
    border-radius: 18px;
    margin: 0;
  }
</style>
